import { InputTypeEnum } from "../enums/inputTypeEnum";
import { InputTypeSharePointClassifier } from "./inputTypeSharePointClassifier";
import { boundField } from "../../redux/models/reduxModels";

export class dataSourceSharePointClassifier extends InputTypeSharePointClassifier {
    constructor() {
        super();
    }

    getSharepointInputType(metadata: any, boundedFields: boundField[]): InputTypeEnum {
        const boundName: string = (metadata?.ContentTypeInputName ?? metadata?.DisplayName)?.trim().toLowerCase();
        const boundedField = boundName && boundedFields?.find(item => item.name?.split(",").some(name => name.trim().toLowerCase() === boundName));
        if (boundedField) {
            return this.determineDatasourceType(boundedField);
        }

        return super.getInputType(metadata);
    }

    determineDatasourceType = (boundedField: boundField) => {
        if (boundedField?.displayAsDropdown && boundedField?.multiSelect) {
            return InputTypeEnum.datasourceMultipleDropdown;
        }

        if (boundedField?.displayAsDropdown) {
            return InputTypeEnum.datasourceDropdown;
        }

        if (boundedField?.multiSelect) {
            return InputTypeEnum.datasourceTagPicker;
        }

        return InputTypeEnum.datasourceText;
    }
}
